"use client";

import React, { type HTMLAttributes, type PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { useHash } from "@/hooks/use-hash.hook";

export type PriceCardItemsProps = {
    anchor: string;
    initialAnchor?: string;
    possibleTabs: string[];
};

const calculateVisibility = (
    hash: string,
    anchor: string,
    initialAnchor: string,
    possibleTabs: string[],
) => {
    if (possibleTabs.indexOf(hash) < 0 && anchor === initialAnchor) {
        return "visible";
    }
    if (hash === undefined) {
        return "hidden";
    }

    return (hash || initialAnchor) === anchor ? "visible" : "hidden";
};

export const PriceCardItemsView = ({
    children,
    className,
    anchor,
    initialAnchor,
    possibleTabs,
}: PriceCardItemsProps & PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
    const hash = useHash();

    const visibility = calculateVisibility(hash ?? "", anchor, initialAnchor ?? "", possibleTabs);

    return <section className={twMerge(className, visibility)}>{children}</section>;
};
